document.addEventListener('DOMContentLoaded',()=>{const toggle=document.querySelector('[data-menu-toggle]');const nav=document.querySelector('[data-site-nav]');if(toggle&&nav)toggle.addEventListener('click',()=>{const open=nav.classList.toggle('is-open');toggle.setAttribute('aria-expanded',String(open));});const variants=document.querySelector('[data-variant-select]');if(variants){const price=document.querySelector('[data-variant-price]');const button=document.querySelector('[data-add-to-cart]');const update=()=>{const choice=variants.options[variants.selectedIndex];if(price&&choice.dataset.price)price.textContent=choice.dataset.price;if(button){button.disabled=choice.dataset.available!=='true';button.textContent=choice.dataset.available==='true'?'Add to cart':'Sold out';}};variants.addEventListener('change',update);update();}});

/* AmpTiltor registered trademark formatting */
(function () {
  function formatTrademark(root) {
    if (!root) return;

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          const parent = node.parentElement;

          if (!parent || !node.nodeValue.includes("®")) {
            return NodeFilter.FILTER_REJECT;
          }

          if (
            parent.closest(
              "script, style, noscript, textarea, select, option, " +
              "svg, sup, [contenteditable]"
            )
          ) {
            return NodeFilter.FILTER_REJECT;
          }

          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    const nodes = [];
    while (walker.nextNode()) {
      nodes.push(walker.currentNode);
    }

    nodes.forEach(node => {
      const parts = node.nodeValue.split("®");
      const fragment = document.createDocumentFragment();

      parts.forEach((part, index) => {
        if (part) {
          fragment.appendChild(document.createTextNode(part));
        }

        if (index < parts.length - 1) {
          const symbol = document.createElement("sup");
          symbol.className = "trademark-symbol";
          symbol.textContent = "®";
          fragment.appendChild(symbol);
        }
      });

      node.replaceWith(fragment);
    });
  }

  function initializeTrademarks() {
    formatTrademark(document.body);

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === "characterData") {
          const parent = mutation.target.parentElement;
          if (parent) formatTrademark(parent);
        } else {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              formatTrademark(node);
            } else if (
              node.nodeType === Node.TEXT_NODE &&
              node.parentElement
            ) {
              formatTrademark(node.parentElement);
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeTrademarks
    );
  } else {
    initializeTrademarks();
  }
})();
